import { render, staticRenderFns } from "./UserSelectBulk.vue?vue&type=template&id=724a6d40&scoped=true"
import script from "./UserSelectBulk.vue?vue&type=script&lang=ts"
export * from "./UserSelectBulk.vue?vue&type=script&lang=ts"
import style0 from "./UserSelectBulk.vue?vue&type=style&index=0&id=724a6d40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724a6d40",
  null
  
)

export default component.exports